<template>
  <div class="mx-auto h-full w-screen md:max-w-xl lg:max-w-3xl bg-gray-800 py-3">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LDefault'
}
</script>
